export default {"src":"/_next/static/media/bq.b0207f71.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};